import { HAlign, VAlign } from './fr3Doc';

/**
 * One positioned drawing instruction, in PDF points from the top-left of the
 * page (port of Fr3DrawOp). The engine produces these and knows nothing about
 * how they are painted; text is deliberately left unwrapped, because line
 * breaking needs real font metrics, which only the emitter has.
 */
export const DrawKind = Object.freeze({ FILL: 'FILL', TEXT: 'TEXT', FRAME: 'FRAME', IMAGE: 'IMAGE' });

export const newDrawOp = () => ({
    kind: null,
    x: 0,
    y: 0,
    w: 0,
    h: 0,
    // TEXT
    text: '',
    fontName: 'Arial',
    fontSize: 10,
    bold: false,
    italic: false,
    underline: false,
    textColor: 0x000000,
    hAlign: HAlign.LEFT,
    vAlign: VAlign.TOP,
    wordWrap: true,
    // FILL
    fillColor: 0xFFFFFF,
    // FRAME
    frameSides: 0,
    frameColor: 0x000000,
    frameWidth: 1,
    // IMAGE
    image: null,
    imageCenter: false,
    /** Name of the originating template object, for diagnostics. */
    source: '',
});

export const fillOp = (x, y, w, h, color) => {
    const op = newDrawOp();
    op.kind = DrawKind.FILL;
    op.x = x;
    op.y = y;
    op.w = w;
    op.h = h;
    op.fillColor = color;
    return op;
};

export const frameOp = (x, y, w, h, sides, color, width) => {
    const op = newDrawOp();
    op.kind = DrawKind.FRAME;
    op.x = x;
    op.y = y;
    op.w = w;
    op.h = h;
    op.frameSides = sides;
    op.frameColor = color;
    op.frameWidth = width;
    return op;
};

export const imageOp = (x, y, w, h, data, center) => {
    const op = newDrawOp();
    op.kind = DrawKind.IMAGE;
    op.x = x;
    op.y = y;
    op.w = w;
    op.h = h;
    op.image = data;
    op.imageCenter = center;
    return op;
};
